import { C } from '../theme'
import { Reveal } from './Reveal'
import { useContent } from '../content/ContentContext'
import { mediaAlt, mediaUrl } from '../content/derive'

export function Volunteer() {
  const volunteer = useContent().home.volunteer ?? {}
  const points = volunteer.points ?? []
  const imageUrl = mediaUrl(volunteer.image)

  return (
    <section id="voluntario" aria-label={volunteer.eyebrow ?? 'Voluntariado'} className="sec" style={{ padding: '104px 40px' }}>
      <div className="stack" style={{ maxWidth: 1040, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center' }}>
        {imageUrl && (
          <Reveal style={{ borderRadius: '10px 220px 10px 220px', overflow: 'hidden', height: 440, boxShadow: '0 22px 54px rgba(21,35,63,.16)' }}>
            <img src={imageUrl} alt={mediaAlt(volunteer.image, volunteer.imageAlt)} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          </Reveal>
        )}
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.red, marginBottom: 18 }}>{volunteer.eyebrow}</div>
          <h2 style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 44, lineHeight: 1.1, margin: '0 0 16px', color: C.ink, letterSpacing: '-.01em' }}>
            {volunteer.title}
          </h2>
          <p style={{ fontSize: 16.5, lineHeight: 1.72, color: C.body, margin: '0 0 24px' }}>
            {volunteer.body}
          </p>
          {points.length > 0 && (
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 28px', display: 'flex', flexDirection: 'column', gap: 12 }}>
              {points.map((p, i) => (
                <li key={p.id ?? i} style={{ display: 'flex', gap: 12, alignItems: 'center', fontSize: 15, color: C.body }}>
                  <span style={{ color: C.red, fontSize: 18 }}>♥</span> {p.text}
                </li>
              ))}
            </ul>
          )}
          {volunteer.ctaLabel && (
            <a className="btn" href="#contacto" style={{ background: C.blue, color: '#fff', fontWeight: 700, fontSize: 15, padding: '15px 30px', borderRadius: 3, textDecoration: 'none', display: 'inline-block' }}>
              {volunteer.ctaLabel}
            </a>
          )}
        </div>
      </div>
    </section>
  )
}
